
      module.exports = {
        functional: true,
        render(_h, _vm) {
          const { _c, _v, data, children = [] } = _vm;

          const {
            class: classNames,
            staticClass,
            style,
            staticStyle,
            attrs = {},
            ...rest
          } = data;

          return _c(
            'svg',
            {
              class: [classNames,staticClass],
              style: [style,staticStyle],
              attrs: Object.assign({"xmlns":"http://www.w3.org/2000/svg","viewBox":"0 0 116 90"}, attrs),
              ...rest,
            },
            children.concat([_c('g',{attrs:{"fill":"none","fill-rule":"evenodd"}},[_c('rect',{attrs:{"width":"115","height":"89","x":".5","y":".5","fill":"#FFF","stroke":"#E0E4EC","rx":"4"}}),_c('path',{attrs:{"fill":"#003457","d":"M54 33h9v43h-9z"}}),_c('path',{attrs:{"fill":"#05B5E4","d":"M84 45h9v31h-9zm-60-3h9v34h-9z"}}),_c('path',{attrs:{"fill":"#C1C8D6","d":"M69 15h9v61h-9zM39 51h9v25h-9z"}})])])
          )
        }
      }
    